import { BotIcon } from '../Icons';
import { colorTokens } from '../variables';

import { Container, Initials } from './ProfileInitials.styles';

export interface ProfileInitialsProps {
  fullName: string;
  size?: number;
  fontSize?: number;
  onLoad?: () => void;
  bgColor?: string;
}

const BOT_NAMES = ['Alert Bot', 'System'];

export const ProfileInitials: React.FC<ProfileInitialsProps> = ({
  fullName,
  size,
  fontSize,
  onLoad,
  bgColor = undefined,
}) => {
  const handleOnLoad = () => (onLoad ? onLoad() : null);

  bgColor = BOT_NAMES.indexOf(fullName) !== -1 ? '#D04DD3' : bgColor;

  return (
    <Container size={size} {...(bgColor && { bgColor })}>
      {BOT_NAMES.indexOf(fullName) !== -1 ? (
        <BotIcon width="20px" height="20px" style={{ color: colorTokens.text.contrast }} />
      ) : (
        <Initials fontSize={fontSize} onLoad={handleOnLoad} data-testid="profile-initials">
          {getNameInitials(fullName)}
        </Initials>
      )}
    </Container>
  );
};

const getNameInitials = (fullName: string): string => {
  if (!fullName) {
    return '';
  }
  const splitNames = fullName.split(' ');

  return splitNames.length > 2
    ? splitNames[0].charAt(0) + splitNames[1].charAt(0) + splitNames[splitNames.length - 1].charAt(0)
    : splitNames[0].charAt(0) + splitNames[1].charAt(0);
};
